module.exports = __webpack_public_path__ + "static/media/ico_simulation_1_5_rule.5bf58523.png";